import React from "react";
import useReveal from "../hooks/useReveal";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import TrustedBy from "../components/TrustedBy";
import ProblemSection from "../components/ProblemSection";
import Solutions from "../components/Solutions";
import BookSection from "../components/BookSection";
import About from "../components/About";
import Testimonial from "../components/Testimonial";
import ContactSection from "../components/ContactSection";
import Philosophy from "../components/Philosophy";
import GlobalBrand from "../components/GlobalBrand";

export default function Home() {
  useReveal();
  return (
    <main>
      <Hero />
      <Marquee />
      <ProblemSection />
      <Philosophy />
      <Solutions />
      <GlobalBrand />
      <BookSection />
      <About />
      <Testimonial />
      <TrustedBy />
      <ContactSection />
    </main>
  );
}
